// extracted by mini-css-extract-plugin
export default {"headerClass":"headerClass__El2bp","tab":"tab__bqcnQ","active":"active__Nhazf","sectionIframeContainer":"sectionIframeContainer__WWMCX","sectionIframe":"sectionIframe__JlCur"};